import React from 'react';
import type { CarouselLink } from '@noths/polaris-client-ribbons-design-system';

import type { LinkCarouselTrackingLinkSource } from 'src/components/organisms/LinkCarousel';
import { LinkCarousel, LinkCarouselTrackingCategory } from 'src/components/organisms/LinkCarousel';
import * as styles from '../styles';

interface AccordionContentProps {
  categoryDescription?: string;
  categoryLinks: CarouselLink[];
  categorySubheading?: string;
  trackingLinkDataSource: LinkCarouselTrackingLinkSource;
}

export const AccordionContent = ({
  categoryDescription,
  categoryLinks,
  categorySubheading,
  trackingLinkDataSource,
}: AccordionContentProps) => (
  <>
    {categorySubheading && <h2 css={styles.subHeading}>{categorySubheading}</h2>}
    {categoryDescription && (
      <div css={styles.copyBlockContentCSS}>
        <div dangerouslySetInnerHTML={{ __html: categoryDescription }} />
      </div>
    )}
    {categoryLinks.length > 0 && (
      <section css={styles.linksCarouselSection}>
        <div css={[styles.insetSectionContent, styles.linksCarouselWrapper]}>
          <LinkCarousel
            title="Categories"
            trackingCategory={LinkCarouselTrackingCategory.ChildCategory}
            links={categoryLinks}
            trackingLinkDataSource={trackingLinkDataSource}
          />
        </div>
      </section>
    )}
  </>
);
